/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExportedLevel } from './exportedLevel';
import type { ExportedModuleInputWorkload } from './exportedModuleInputWorkload';
import type { ExportedTaskInput } from './exportedTaskInput';
import type { ExportedModuleInputSourceModuleId } from './exportedModuleInputSourceModuleId';

/**
 * Module export format
 */
export interface ExportedModuleInput {
  title: string;
  description?: string;
  language?: string;
  levels?: ExportedLevel[];
  workload?: ExportedModuleInputWorkload;
  tasks?: ExportedTaskInput[];
  author_id: string;
  source_module_id?: ExportedModuleInputSourceModuleId;
}
